/**
 * Public + authenticated subscription API.
 */
import API from "../../services/api";

const BASE = "/subscription";
const PUBLIC = `${BASE}/public`;

export const getPublicPlans = () => API.get(`${PUBLIC}/plans`).then((r) => r.data);

export const getCurrentSubscription = () => API.get(`${BASE}/current`).then((r) => r.data);
export const getFeatures = () => API.get(`${BASE}/features`).then((r) => r.data);
export const getUsage = () => API.get(`${BASE}/usage`).then((r) => r.data);
export const getPlans = () => API.get(`${BASE}/plans`).then((r) => r.data);

export const getInvoices = () => API.get(`${BASE}/invoices`).then((r) => r.data);
export const getPayments = () => API.get(`${BASE}/payments`).then((r) => r.data);
export const getHistory = () => API.get(`${BASE}/history`).then((r) => r.data);

export const createCheckout = (invoiceId) =>
  API.post(`${BASE}/checkout`, { invoice_id: invoiceId }).then((r) => r.data);

export const verifyPayment = (body) =>
  API.post(`${BASE}/verify-payment`, body).then((r) => r.data);

export const renewSubscription = (body = {}) =>
  API.post(`${BASE}/renew`, body).then((r) => r.data);

export const upgradePlan = (plan, billingCycle = "monthly", coupon = null) =>
  API.post(`${BASE}/upgrade`, null, { params: { plan, billing_cycle: billingCycle, coupon } }).then((r) => r.data);

export const createChangeRequest = (body) => API.post(`${BASE}/change-request`, body).then((r) => r.data);
export const getMyChangeRequests = () => API.get(`${BASE}/change-requests`).then((r) => r.data);

export const getAddonCatalog = () => API.get(`${BASE}/addons/catalog`).then((r) => r.data);
export const getMyAddons = () => API.get(`${BASE}/addons`).then((r) => r.data);

export function subErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return e?.message || "Request failed";
}

export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error("Failed to load Razorpay checkout"));
    document.body.appendChild(script);
  });
}

export async function openRazorpayCheckout(checkout, onSuccess) {
  const Razorpay = await loadRazorpayScript();
  return new Promise((resolve, reject) => {
    const options = {
      key: checkout.key_id,
      amount: Math.round(Number(checkout.amount) * 100),
      currency: checkout.currency || "INR",
      name: "BrixiGo Payroll",
      description: checkout.description,
      order_id: checkout.order_id,
      prefill: checkout.prefill || {},
      theme: { color: "#2563EB" },
      handler: async (response) => {
        try {
          const result = await verifyPayment({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          });
          onSuccess?.(result);
          resolve(result);
        } catch (e) {
          reject(e);
        }
      },
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
    };
    const rzp = new Razorpay(options);
    rzp.on("payment.failed", (resp) => {
      reject(new Error(resp?.error?.description || "Payment failed"));
    });
    rzp.open();
  });
}
